import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Components
// @ts-ignore
import SubmittingButton from 'components/SubmittingButton';

// Global Actions
// @ts-ignore
import { requestSubmitTimesheet } from 'services/timesheets/actions';

// Global Selectors
import {
    makeSelectQueryStringNumberValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

interface ConnectedProps {
    timesheetId?: number;
}

interface DispatchProps {
    requestSubmitTimesheet: Function;
}

export interface Props extends ConnectedProps, DispatchProps {}

export class TimesheetSubmitModalButton extends React.PureComponent<Props> {
    handleClick = () => {
        const { timesheetId } = this.props;
        this.props.requestSubmitTimesheet(timesheetId);
    };

    render(): React.ReactElement {
        const { timesheetId } = this.props;
        return (
            <SubmittingButton
                type="submit"
                namespace="TIMESHEET_SUBMIT"
                primary
                fluid
                onClick={this.handleClick}
                disabled={!timesheetId}
            >
                Confirm
            </SubmittingButton>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    timesheetId: makeSelectQueryStringNumberValue('selectedTimesheet')
});

export default connect(
    mapStateToProps,
    { requestSubmitTimesheet }
)(TimesheetSubmitModalButton);
